function initSub() {
  let newDiv = document.createElement("div");
  newDiv.style="z-index: 9999999;  position: fixed; top: 0;  left: 0;  bottom: 0;  right: 0;"
  newDiv.innerHTML = `<div class="react-responsive-modal-root" style="z-index:999999;" id="sub-all-modal" data-testid="root"><div style='z-index:99992;top: 0;left: 0;right: 0;bottom: 0;' class="react-responsive-modal-overlay pp-overlay" data-testid="overlay" aria-hidden="true" style="animation: 200ms ease 0s 1 normal none running react-responsive-modal-overlay-in;"></div><div style='z-index:99993;position: fixed;left: 50%;top: 50%;transform: translate(-50%, -50%);' class="react-responsive-modal-container react-responsive-modal-containerCenter" data-testid="modal-container"><div class="react-responsive-modal-modal pp-modal" style="margin:0 auto;min-width:99vw;" role="dialog" aria-modal="true" data-testid="modal" tabindex="-1" style="animation: 200ms ease 0s 1 normal none running react-responsive-modal-modal-in;"><div class="ecomsend__Modal__Container _modalContainer_4tu8s_2 _adminModalContainer_4tu8s_251"><div class="ecomsend__Modal__Content _modalContent_4tu8s_22 _size-standard_4tu8s_34 _cornerRadius-standard_4tu8s_64" style="background-color: rgb(255, 255, 255);"><div class="ecomsend__Modal__CustomDialogWrapper _myCustomDialogWrapper_4tu8s_29"><div id="sub-content-main" class="ecomsend__Modal__CustomDialog _myCustomDialog_4tu8s_29 _center_4tu8s_116"><div id="sub-close" class="ecomsend__Modal__CloseButton _closeBtn_4tu8s_236"><svg width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg" style="width: 16px; height: 16px;"><path d="m9.414 8 6.293-6.293A1 1 0 0 0 14.293.293L8 6.586 1.707.293A1 1 0 1 0 .293 1.707L6.586 8 .293 14.293a1 1 0 1 0 1.414 1.414L8 9.414l6.293 6.293a.997.997 0 0 0 1.631-.324 1 1 0 0 0-.217-1.09L9.414 8Z" fill="#6C6B80"></path></svg></div><header class="ecomsend__Modal__TitleText _titleText_4tu8s_37" style="color: rgb(18, 18, 18);">Be the first to know</header><div class="ecomsend__Modal__TitleHelpText _titleHelpText_4tu8s_40" style="color: rgb(69, 69, 69);">Get the latest product releases and best deals delivered to your inbox.</div><div><div id="sub-valbox" class="ecomsend__Input__Wrap _myCustomInputContent_1dnjt_2 _standard_1dnjt_62"><input class="ecomsend__Input__Input _myCustomInput_1dnjt_2 _standard_1dnjt_62 _input-radius-standard_1dnjt_68" id="email" placeholder="Email address" type="email" value="" style="--color: #121212; color: rgb(18, 18, 18);"></div></div><div id="subscribe" class="ecomsend__Button _xButton_1vm0o_2 _btn-radius-standard_1vm0o_44" style="--bg-color: #121212; background: rgb(18, 18, 18); color: rgb(255, 255, 255);"><div class="_text_1vm0o_33">Subscribe</div></div><div id="sub-thanks" class="ecomsend__Modal__CloseText _closeText_4tu8s_174" style="--color: #334FB4; background: rgb(51, 79, 180);">No, thanks</div><div class="ecomsend__Modal__DescriptionText _descriptionText_4tu8s_195" style="color: rgb(69, 69, 69);"></div></div></div></div></div></div></div></div>`;

  newDiv?.querySelector("#sub-close")?.addEventListener("click", () => {
    successClickBack(0);
  });

  newDiv?.querySelector("#sub-thanks")?.addEventListener("click", () => {
    successClickBack(1);
  });

  newDiv?.querySelector("#subscribe")?.addEventListener("click", subsClick);

  newDiv?.querySelector("#email")?.addEventListener("input", () => {
    const subWarringElement = document.querySelector("#sub-warring");
    if (subWarringElement) {
      subWarringElement.parentNode.removeChild(subWarringElement);
    }
  });

  document.body.appendChild(newDiv);
  document.body.style.overflow = "hidden";
}

async function subsClick() {
  const newDiv = document?.querySelector("#sub-all-modal");
  const value = newDiv?.querySelector("#email").value;
  if (/\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/?.test(value)) {
    let result = await submitInput();
    updateSubscribeButton(false);
    console.log("result", result);
    if (result?.error !== undefined && result?.error?.message) {
      updateWarringText(result?.error?.message);
    } else if (result?.success && typeof result?.success === "number") {
      successCallBack();
    } else {
      updateWarringText("Problem encountered, please try again later.");
    }
  } else {
    updateWarringText();
  }
}
function successCallBack() {
  const oldDom = document?.querySelector("#sub-content-main");
  oldDom.innerHTML =
    '<div id="sub-close" class="ecomsend__Modal__CloseButton _closeBtn_4tu8s_236"><svg width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg" style="width: 16px; height: 16px;"><path d="m9.414 8 6.293-6.293A1 1 0 0 0 14.293.293L8 6.586 1.707.293A1 1 0 1 0 .293 1.707L6.586 8 .293 14.293a1 1 0 1 0 1.414 1.414L8 9.414l6.293 6.293a.997.997 0 0 0 1.631-.324 1 1 0 0 0-.217-1.09L9.414 8Z" fill="#6C6B80"></path></svg></div><header class="ecomsend__Modal__TitleText _titleText_4tu8s_37" style="color: rgb(18, 18, 18);">Thanks for subscribing! 🎉</header><div class="ecomsend__Modal__TitleHelpText _titleHelpText_4tu8s_40" style="color: rgb(69, 69, 69);">Be on the look out for our latest releases and best deals.</div><div id="sub-success" class="ecomsend__Button _xButton_1vm0o_2 _btn-radius-standard_1vm0o_44" style="--bg-color: #121212; background: rgb(18, 18, 18); color: rgb(255, 255, 255);"><div class="_text_1vm0o_33">OK</div></div>';
  oldDom?.querySelector("#sub-success").addEventListener("click", () => {
    successClickBack(2);
  });
  oldDom?.querySelector("#sub-success").addEventListener("click", () => {
    successClickBack(2);
  });
}
function successClickBack(val) {
  setLKCookie("LK-subOpenView", "open", 3, ".topdon.com");
  // localStorage?.setItem(
  //   "LK-subOpenView",
  //   JSON.stringify({ time: new Date()?.getTime() })
  // );
  const now = document?.querySelector("#sub-all-modal");
  now?.parentNode?.parentNode?.removeChild(now?.parentNode);
  document.body.removeAttribute("style");
}
function setLKCookie(name, value, days, domain) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie =
    name +
    "=" +
    value +
    expires +
    "; path=/; domain=" +
    domain +
    "; secure; samesite=None";
}
function getLKCookie(name) {
  var nameEQ = name + "=";
  var cookies = document.cookie.split(";");
  for (var i = 0; i < cookies.length; i++) {
    var cookie = cookies[i];
    while (cookie.charAt(0) === " ")
      cookie = cookie.substring(1, cookie.length);
    if (cookie.indexOf(nameEQ) === 0)
      return cookie.substring(nameEQ.length, cookie.length);
  }
  return null;
}
function updateWarringText(customText) {
  const box = document.querySelector("#sub-valbox");
  const subWarring = document.querySelector("#sub-warring");
  const defaultText = "Please enter valid email address!";

  if (subWarring) {
    // 使用外部传入的字符串，或者使用默认的文本内容
    const newText = customText || defaultText;
    subWarring.querySelector("._errText_1dz3r_24").textContent = newText;
  } else {
    const warringBox = document.createElement("div");
    warringBox.id = "sub-warring";
    warringBox.style = "display: flex;align-items: flex-start;"
    warringBox.className =
      "ecomsend-SpinWheel__Modal__ErrTextMarkup _errContent_1dz3r_2 _embed_1dz3r_8";
    warringBox.style.color = "rgb(215, 44, 13)";
    warringBox.style.fill = "rgb(215, 44, 13)";

    // 使用外部传入的字符串，或者使用默认的文本内容
    const newText = customText || defaultText;

    warringBox.innerHTML = `
            <div class="_errIcon_1dz3r_12" style="width: 21px;height: 21px;">
                <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10 18a8 8 0 1 1 0-16 8 8 0 0 1 0 16zM9 9a1 1 0 0 0 2 0V7a1 1 0 1 0-2 0v2zm0 4a1 1 0 1 0 2 0 1 1 0 0 0-2 0z" fill="#5C5F62"></path>
                </svg>
            </div>
            <span class="_errText_1dz3r_24" style="text-align: left;">${newText}</span>
        `;
    box.parentNode.insertBefore(warringBox, box.nextElementSibling);
  }
}

function updateSubscribeButton(isLoading) {
  const originalDiv = document.getElementById("subscribe");

  // 如果传入 true，则生成 loading 的 DOM 结构
  if (isLoading) {
    const newDiv = document.createElement("div");
    newDiv.id = originalDiv.id;
    newDiv.className =
      "ecomsend__Button _xButton_1vm0o_2 _btn-radius-standard_1vm0o_44";
    newDiv.style =
      "--bg-color: #121212; background: rgb(18, 18, 18); color: rgb(255, 255, 255);";
    newDiv.innerHTML =
      '<div class="_loadingBox_1vm0o_24"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><circle transform="translate(8 0)" cx="0" cy="16" r="0"><animate attributeName="r" values="0; 4; 0; 0" dur="1.2s" repeatCount="indefinite" begin="0" keyTimes="0;0.2;0.7;1" keySplines="0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8;0.2 0.6 0.4 0.8" calcMode="spline"></animate></circle><circle transform="translate(16 0)" cx="0" cy="16" r="0"><animate attributeName="r" values="0; 4; 0; 0" dur="1.2s" repeatCount="indefinite" begin="0.3" keyTimes="0;0.2;0.7;1" keySplines="0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8;0.2 0.6 0.4 0.8" calcMode="spline"></animate></circle><circle transform="translate(24 0)" cx="0" cy="16" r="0"><animate attributeName="r" values="0; 4; 0; 0" dur="1.2s" repeatCount="indefinite" begin="0.6" keyTimes="0;0.2;0.7;1" keySplines="0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8;0.2 0.6 0.4 0.8" calcMode="spline"></animate></circle></svg></div>';

    // 替换原始的 div 元素
    originalDiv.parentNode.replaceChild(newDiv, originalDiv);
  } else {
    // 如果传入 false，则生成普通的 Subscribe 按钮 DOM 结构
    const newDiv = document.createElement("div");
    newDiv.id = originalDiv.id;
    newDiv.className =
      "ecomsend__Button _xButton_1vm0o_2 _btn-radius-standard_1vm0o_44";
    newDiv.style =
      "--bg-color: #121212; background: rgb(18, 18, 18); color: rgb(255, 255, 255);";
    newDiv.innerHTML = '<div class="_text_1vm0o_33">Subscribe</div>';

    // 替换原始的 div 元素
    originalDiv.parentNode.replaceChild(newDiv, originalDiv);
    newDiv?.addEventListener("click", subsClick);
  }
}
function submitInput() {
  return new Promise((res, rej) => {
    updateSubscribeButton(true);
    var xhr = new XMLHttpRequest();
    var url = "https://official-web-api.topdon.com/api/subscribe";
    var params =
      "email=" +
      encodeURIComponent(document.getElementById("email").value) +
      "&siteFrom=AU" +
      "&from=POP";
    xhr.open("POST", url, true);
    xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
    xhr.setRequestHeader("X-Requested-With", "Hiwie-Fetch");
    xhr.onreadystatechange = function () {
      if (xhr.readyState == 4) {
        let responseData = JSON.parse(xhr.responseText);
        res(responseData);
      }
    };

    xhr.send(params);
  });
}

const now = getLKCookie("LK-subOpenView");

if (now === null) {
  initSub();
}
